import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=148e3e88"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports